<template>
  <div
    :class="{'preview-container':true,'preview-container-pop':type==='pop'}"
    style="margin-top: 30px;"
  >
    <div class="img-bg">
      <img :src="iconFileList[0].url" alt="icon" class="icon-img" v-if="hideIconUpload && iconFileList.length>0" />
      <p class="app-name" :title="form.app_name">{{ form.app_name }}</p>
      <img src="../../../assets/img/point-bg.png" class="point-img" v-if="!hideIconUpload" />
      <img
        :src="resizedImageFileList[0].url"
        alt="Product Image"
        class="product-img"
        v-if="hideProductImgUpload && resizedImageFileList.length > 0"
      />
    </div>
    <p class="tip-title">
      {{ $t('messages.createCampaign.create35') }}
      <br />
      <a>https://jadiduit.id/</a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'previewImg',
  props: {
    iconFileList: {
      type: Array,
      default() {
        return [{url:''}]
      },
    },
    resizedImageFileList: {
      type: Array,
      default() {
        return [{url:''}]
      },
    },
    form:{
      type: Object,
      default() {
        return {app_name:''}
      },
    },
    hideIconUpload: {
      type: Boolean,
      default: false,
    },
    hideProductImgUpload: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'page',
    },
  },
};
</script>

<style lang="scss">
.preview-container {
  margin-left: 0;
  .img-bg {
    background: url('../../../assets/img/viewCampaign.png') no-repeat center;
    background-size: cover;
    width: 250px;
    height: 523px;
    position: relative;
    .icon-img {
      position: absolute;
      top: 150px;
      left: 29px;
      width: 20px;
      height: 20px;
    }
    .app-name {
      position: absolute;
      top: 151px;
      left: 54px;
      font-weight: 400;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
      max-width: 120px;
      font-size: 14px;
      color: #606266;
    }
    .point-img {
      width: 43px;
      height: 20px;
      position: absolute;
      top: 142px;
      right: 21px;
    }
    .product-img {
      position: absolute;
      top: 174px;
      left: 29px;
      width: 192px;
      height: 85px;
      border-radius: 2px;
    }
  }
  .tip-title {
    width: 250px;
    height: 46px;
    font-size: 14px;
    font-weight: 400;
    color: #909399;
    line-height: 16px;
    margin-top: 18px;
    text-align: center;
  }
}
.preview-container-pop{
  display: none;
}

@media screen and (max-width: 766px) {
  .preview-container{
    display: none;
  }
  .preview-container-pop{
    display: block;
    margin-top: 0 !important;
    .img-bg{
      margin: 0 auto;
    }    
    .tip-title{
      margin:18px auto 0;
    }
  }
}
</style>